import { render } from "./BiotronPageUpdated.vue?vue&type=template&id=a971bac6"
import script from "./BiotronPageUpdated.vue?vue&type=script&lang=js"
export * from "./BiotronPageUpdated.vue?vue&type=script&lang=js"

import exportComponent from "../../../../biotron-complaint-20260813/WebMidiVue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__